export default __webpack_public_path__ + "static/media/umuma-acik-mahaller.08b2c977.jpg";